import Immutable from 'immutable';
import {setCloseStepValidation} from './closeStepValidation';
import EquipmentUtils from 'utils/EquipmentUtils';
import TextFormatter from 'utils/TextFormatter';

export const getSqcResults = (state, action) => {

    const results = [];
    const equipmentDetails = state.getIn(['workOrderDetails', action.orderId, 'equipmentDetails', 'details']);
    const sqcAbleOutlets = EquipmentUtils.getSqcableEquipment(equipmentDetails);

    sqcAbleOutlets.forEach((outlet) => {

        const macAddress = TextFormatter
            .formatMacAddress(outlet.get('macAddress'))
            .toLowerCase();
        const sqcData = state.getIn([
            'workOrderDetails',
            action.orderId,
            'sqcResults',
            'details',
            macAddress,
            'data'
        ]);

        if (sqcData) {
            results.push(sqcData);
        }
    });

    return Immutable.List(results);
};

const copySqcToOrderClose = (state, action) => {
    return state.setIn([
        'workOrderDetails',
        action.orderId,
        'orderClose',
        'details',
        'closeOrderRequest',
        'sqcInfoRequest',
        'data'
    ], getSqcResults(state, action));
};

export const setSqcResults = (state, action) => {

    if (!action.payload.data || !action.payload.data.macaddress) {
        return state;
    }

    state = state.setIn([
        'workOrderDetails', action.orderId, 'sqcResults', 'details',
        action
            .payload
            .data
            .macaddress
            .toLowerCase()
    ], Immutable.fromJS(action.payload)).setIn([
        'workOrderDetails', action.orderId, 'sqcResults', 'details',
        action
            .payload
            .data
            .macaddress
            .toLowerCase(),
        'created'
    ], new Date()).setIn([
        'workOrderDetails', action.orderId, 'sqcResults', 'loading'
    ], false);

    //Amherst Fix
    if(action.payload.data.provinfo && action.payload.data.provinfo.status === 'SUCCESS' && action.payload.data.certificate === null) {
        state = state.setIn([
            'workOrderDetails', action.orderId, 'sqcResults', 'bypassBecauseOfFailure'
        ], true);
    }

    state = copySqcToOrderClose(state, action);

    return setCloseStepValidation(state, action.orderId);
};

export const setSqcGenerateStarted = (state, action) => {
    state = state.setIn([
        'workOrderDetails', action.orderId, 'sqcResults', 'loading'
    ], true).setIn([
        'workOrderDetails', action.orderId, 'sqcResults', 'bypassBecauseOfFailure'
    ], false);

    return setCloseStepValidation(state, action.orderId);
};

export const setSqcGenerateFailed = (state, action) => {

    state = state.setIn([
        'workOrderDetails', action.orderId, 'sqcResults', 'loading'
    ], false).setIn([
        'workOrderDetails', action.orderId, 'sqcResults', 'bypassBecauseOfFailure'
    ], true);

    return setCloseStepValidation(state, action.orderId);
};


// WEBPACK FOOTER //
// ./src/reducers/work-order/sqc.js